import Papa from "papaparse";

const parseCsv = async (file, config) => {
  console.log("parsing csv");
  return new Promise((resolve, reject) => {
    const data = [];
    Papa.parse(file, {
      delimiter: ",",
      header: true,
      transformHeader: (h) => (h ? h.toLowerCase() : "empty"),
      skipEmptyLines: true,
      step: ({ data: { empty, ...rest } = {}, errors }, parser) => {
        if (errors.length) { reject(errors[0]); }
        data.push(rest);
      },
      complete: () => {
        resolve(data);
      },
      error: (err) => {
        throw err;
      },
    });
  });
};

export default parseCsv;
